import {http} from '@/http/index.js';

async function getProfile() {
  return http.get('/consumer').then((response) => response.data.data);
}

export {getProfile};
